import copy from 'copy-to-clipboard';

export default function copyToClipboard(string) {
    copy(string);
}
